import React from 'react';

import { useBaseWidget } from 'hooks/useBaseWidget';

import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';
import { ExportDropdown } from 'components/common/ExportDropdown/exportDropdown';
import YaxisXaxisLollipop from 'components/common/Lollipop/YaxisXaxis/yaxisXaxisLollipop';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { useActivitiesGraphProvider } from 'components/widgets/ActivitiesGraph/ActivitiesGraph.provider';
import { useActivitiesGraphLogic } from 'components/widgets/ActivitiesGraph/components/ActivitiesGraph.logic';
import { CustomFilter } from 'components/widgets/ActivitiesGraph/components/CustomFilter/CustomFilter';

const title = 'Activities';
const id = 'activities';

export const ActivitiesGraph = ({ projectId, contractId, latestVersionId, widgetId }) => {
    const { ui, api } = useActivitiesGraphProvider({ latestVersionId });

    const { logic } = useActivitiesGraphLogic({ ui, api });

    const { subTitle } = useBaseWidget({ id, widgetId, projectId, contractId, latestVersionId, title });

    return (
        <ErrorBoundary>
            <WidgetWithTitle
                id={id}
                title={title}
                tooltip={api.activitiesGraph.data?.info}
                titleComponents={[
                    <CustomFilter
                        key={'CustomFilter'}
                        showTasksConstraints={ui.state.showTasksConstraints}
                        setShowTasksConstraints={ui.setters.setShowTasksConstraints}
                        showMilestones={ui.state.showMilestones}
                        setShowMilestones={ui.setters.setShowMilestones}
                        handleFilter={ui.setters.setFilter}
                    />,
                    <ExportDropdown title={title} key={'export'} subTitle={subTitle} />,
                ]}
            >
                {!api.activitiesGraph.isFetching && (
                    <YaxisXaxisLollipop
                        dataset={logic.dataset}
                        constraints={logic.constraints}
                        filter={ui.state.filter}
                        showRels={ui.state.showTasksConstraints}
                        nowDate={api.activitiesGraph.data?.versionDate}
                    />
                )}
            </WidgetWithTitle>
        </ErrorBoundary>
    );
};
